export const formatarDataInput = (data: Date) => {
  let dataDividida = data.toString().split("T");
  return {
    data: dataDividida[0],
    hora: dataDividida[1].slice(0, 5)
  };
}